import React from "react";

function inline(text) {
  return text.split(/(\*\*[^*]+\*\*|`[^`]+`)/g).map((part, index) => {
    if (part.startsWith("**") && part.endsWith("**")) return <strong key={index}>{part.slice(2, -2)}</strong>;
    if (part.startsWith("`") && part.endsWith("`")) return <code key={index}>{part.slice(1, -1)}</code>;
    return part;
  });
}

// Render text as React nodes, never HTML supplied by the model.
export default function AIReply({ content }) {
  const lines = String(content).split(/\r?\n/);
  const blocks = [];
  for (let i = 0; i < lines.length; i++) {
    const line = lines[i].trim();
    if (!line) continue;
    if (line.startsWith("```")) {
      const code = [];
      while (++i < lines.length && !lines[i].trim().startsWith("```")) code.push(lines[i]);
      blocks.push(<pre key={i}><code>{code.join("\n")}</code></pre>);
    } else if (/^\d+\.\s/.test(line) || /^[-*]\s/.test(line)) {
      const ordered = /^\d+\.\s/.test(line);
      const pattern = ordered ? /^\d+\.\s/ : /^[-*]\s/;
      const items = [];
      const start = ordered ? Number(line.match(/^\d+/)[0]) : undefined;
      while (i < lines.length && pattern.test(lines[i].trim())) {
        items.push(<li key={i}>{inline(lines[i].trim().replace(pattern, ""))}</li>);
        i++;
      }
      i--;
      blocks.push(ordered ? <ol key={i} start={start}>{items}</ol> : <ul key={i}>{items}</ul>);
    } else if (/^#{1,6}\s/.test(line)) {
      blocks.push(<h4 key={i}>{inline(line.replace(/^#{1,6}\s/, ""))}</h4>);
    } else {
      const field = line.match(/^(Name|Telephone|ID|Org unit|Category|Status):\s*(.*)$/i);
      blocks.push(<p key={i}>{field ? <><strong>{field[1]}:</strong> {inline(field[2])}</> : inline(line)}</p>);
    }
  }
  return <div className="admin-ai-reply">{blocks}</div>;
}
